import {useState} from "react";
import {Link} from "react-router-dom";

export default function Header() {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const [intakeOpen, setIntakeOpen] = useState(false);

    return (
        <header className="bg-[#1C3353] text-white px-[5%] py-4 sticky top-0 z-50">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-10">

                    <a href="/">
                        <img className="w-12 h-12" src="img/logox.png" alt="logo"/>
                    </a>

                    <div className="flex-col gap-1 ">

                        <div className="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor"
                                 viewBox="0 0 16 16">
                                <path
                                    d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
                            </svg>

                            <a href="tel:+13062217868" className="hover:text-green-400 transition">
                                +1 (306) 221-7868
                            </a>
                        </div>

                        <div className="flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="currentColor"
                                 viewBox="0 0 16 16">
                                <path
                                    d="M2 2a2 2 0 0 0-2 2v8.01A2 2 0 0 0 2 14h5.5a.5.5 0 0 0 0-1H2a1 1 0 0 1-.966-.741l5.64-3.471L8 9.583l7-4.2V8.5a.5.5 0 0 0 1 0V4a2 2 0 0 0-2-2zm3.708 6.208L1 11.105V5.383zM1 4.217V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v.217l-7 4.2z"/>
                                <path
                                    d="M14.247 14.269c1.01 0 1.587-.857 1.587-2.025v-.21C15.834 10.43 14.64 9 12.52 9h-.035C10.42 9 9 10.36 9 12.432v.214C9 14.82 10.438 16 12.358 16h.044c.594 0 1.018-.074 1.237-.175v-.73c-.245.11-.673.18-1.18.18h-.044c-1.334 0-2.571-.788-2.571-2.655v-.157c0-1.657 1.058-2.724 2.64-2.724h.04c1.535 0 2.484 1.05 2.484 2.326v.118c0 .975-.324 1.39-.639 1.39-.232 0-.41-.148-.41-.42v-2.19h-.906v.569h-.03c-.084-.298-.368-.63-.954-.63-.778 0-1.259.555-1.259 1.4v.528c0 .892.49 1.434 1.26 1.434.471 0 .896-.227 1.014-.643h.043c.118.42.617.648 1.12.648m-2.453-1.588v-.227c0-.546.227-.791.573-.791.297 0 .572.192.572.708v.367c0 .573-.253.744-.564.744-.354 0-.581-.215-.581-.8Z"/>
                            </svg>

                            <a href="mailto:info@rcotax.ca" className="hover:text-green-400 transition">
                                info@rcotax.ca
                            </a>
                        </div>

                    </div>
                </div>

                <div className="hidden md:flex items-center">
                    <nav className="flex items-center">

                        <a href="/" className="ml-5 font-bold hover:text-[#2f855a]">Home</a>
                        <a href="/#about" className="ml-5 font-bold hover:text-[#2f855a]">About Us</a>

                        <div className="relative ml-5 group">
                            <a href="/#services"
                               className=" font-bold flex items-center gap-1 px-3 py-2 rounded-lg transition-colors duration-200 group-hover:bg-[#2E4D78] group-hover:text-white">
                                Services
                                <span className="transition-transform group-hover:rotate-180">▼</span>
                            </a>

                            <div
                                className=" absolute left-0 top-full mt-1 min-w-[300px] bg-[#1C3353] border border-gray-500 rounded-xl shadow-lg py-2 opacity-0 invisible translate-y-2 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-200">
                                <a href="/services#accounting"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Accounting & Financial Reporting
                                </a>
                                <a href="/services#tax"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Tax Preparation & Tax Planning
                                </a>
                                <a href="/services#payroll"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Payroll Services
                                </a>
                                <a href="/services#advisory"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Business Advisory & Planning
                                </a>
                                <a href="/services#insurance"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Insurance Solutions
                                </a>
                                <a href="/services#investment"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Investment Guidance
                                </a>
                                <a href="/services#notary"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Notary Public Services
                                </a>
                            </div>
                        </div>

                        <a href="/#contact" className="ml-5 font-bold hover:text-[#2f855a]">Contact</a>
                        <div className="relative ml-5 group">
                            <button
                               className=" font-bold flex items-center gap-1 px-3 py-2 rounded-lg transition-colors duration-200 group-hover:bg-[#2E4D78] group-hover:text-white">
                                Intake Form
                                <span className="transition-transform group-hover:rotate-180">▼</span>
                            </button>

                            <div
                                className=" absolute -left-8 top-full mt-1 min-w-[220px] bg-[#1C3353] border border-gray-500 rounded-xl shadow-lg py-2 opacity-0 invisible translate-y-2 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 transition-all duration-200">
                                <Link to="/intake"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Personal Intake Form
                                </Link>
                                <Link to="/businessIntake"
                                   className="block px-4 py-2 hover:bg-[#F3C879] hover:text-[#1C3353] rounded-md mx-2">
                                    Business Intake Form
                                </Link>
                            </div>

                        </div>
                    </nav>
                </div>

                <button onClick={() => setMobileOpen(!mobileOpen)} id="menuBtn" className="md:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                         className="bi bi-list" viewBox="0 0 16 16">
                        <path fillRule="evenodd"
                              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
                    </svg>
                </button>

            </div>
            <div
                className={`md:hidden overflow-hidden transition-all duration-300 
    ${mobileOpen ? "max-h-[500px] opacity-100 mt-4" : "max-h-0 opacity-0"}`}
            >
                <nav className="flex flex-col gap-4 border-t border-white/20 pt-4">

                    <a href="/"
                       onClick={() => setMobileOpen(false)}
                       className="font-bold hover:text-[#F3C879]">
                        Home
                    </a>

                    <a href="/#about"
                       onClick={() => setMobileOpen(false)}
                       className="font-bold hover:text-[#F3C879]">
                        About Us
                    </a>

                    <div>
                        <button
                            onClick={() => setServicesOpen(!servicesOpen)}
                            className="font-bold w-full flex justify-between items-center hover:text-[#F3C879]"
                        >
                            Services
                            <span className={`transition-transform ${servicesOpen ? "rotate-180" : ""}`}>▼</span>
                        </button>

                        <div className={`pl-4 flex flex-col gap-2 transition-all duration-300 ${servicesOpen ? "max-h-96 opacity-100 pt-2" : "max-h-0 opacity-0 overflow-hidden"}`}>

                            <a href="/services#accounting" onClick={() => setMobileOpen(false)}>Accounting & Financial Reporting</a>
                            <a href="/services#tax" onClick={() => setMobileOpen(false)}>Tax Preparation & Planning</a>
                            <a href="/services#payroll" onClick={() => setMobileOpen(false)}>Payroll Services</a>
                            <a href="/services#advisory" onClick={() => setMobileOpen(false)}>Business Advisory</a>
                            <a href="/services#insurance" onClick={() => setMobileOpen(false)}>Insurance Solutions</a>
                            <a href="/services#investment" onClick={() => setMobileOpen(false)}>Investment Guidance</a>
                            <a href="/services#notary" onClick={() => setMobileOpen(false)}>Notary Public</a>

                        </div>
                    </div>

                    <a href="/#contact"
                       onClick={() => setMobileOpen(false)}
                       className="font-bold hover:text-[#F3C879]">
                        Contact
                    </a>

                    <div>
                        <button
                            onClick={() => setIntakeOpen(!intakeOpen)}
                            className="font-bold w-full flex justify-between items-center hover:text-[#F3C879]"
                        >
                            Intake Form
                            <span className={`transition-transform ${intakeOpen ? "rotate-180" : ""}`}>▼</span>
                        </button>

                        <div className={`pl-4 flex flex-col gap-2 transition-all duration-300
                ${intakeOpen ? "max-h-40 opacity-100 pt-2" : "max-h-0 opacity-0 overflow-hidden"}`}>

                            <Link to="/intake" onClick={() => setMobileOpen(false)}>Personal Intake Form</Link>
                            <Link to="/businessIntake" onClick={() => setMobileOpen(false)}>Business Intake Form</Link>

                        </div>
                    </div>

                </nav>
            </div>
        </header>
    );
}
